import {
  ChangeDetectorRef,
  ContentChild,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
import { ReplaySubject, merge, takeUntil, tap } from 'rxjs';
import { touchedChanges } from '../../helpers/touched-changes';
import { ValidationErrorsComponent } from '../components/validation-errors/validation-errors.component';
import { ErrorsHostDirective } from './errors-host.directive';

@Directive({
  selector: '[appIfInvalid]',
})
export class IfInvalidDirective implements OnInit, OnDestroy {
  @Input()
  appIfInvalid!: FormControl;

  @Input()
  validationErrors!: ValidationErrors;

  @Input()
  errorClassName: string = 'fields__item_error';

  @ContentChild(ErrorsHostDirective, { static: false })
  errorsHost!: ErrorsHostDirective;

  private destroy$ = new ReplaySubject<void>(1);

  private hasView = false;

  constructor(
    private el: ElementRef,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const classList = this.el?.nativeElement?.classList;
    merge(this.appIfInvalid.statusChanges, touchedChanges(this.appIfInvalid))
      ?.pipe(
        takeUntil(this.destroy$),
        tap(() => {
          if (!this.appIfInvalid.touched) {
            if (classList) {
              classList.remove(this.errorClassName);
            }
            return;
          }
          if (this.appIfInvalid.status === 'VALID') {
            if (classList) {
              classList.remove(this.errorClassName);
            }
            if (this.hasView) {
              this.errorsHost.viewContainerRef.clear();
              this.hasView = false;
            }
            return;
          }

          if (this.appIfInvalid.status === 'INVALID') {
            if (classList) {
              classList.add(this.errorClassName);
            }
            if (!this.hasView) {
              const componentRef =
                this.errorsHost.viewContainerRef.createComponent(
                  ValidationErrorsComponent,
                );
              componentRef.instance.fc = this.appIfInvalid;
              componentRef.instance.errors = this.validationErrors;
              this.hasView = true;
            }
            return;
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
